import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { SettingsContext } from '../contexts/SettingsContext';

function ThemeToggle() {
  const location = useLocation();
  const { settings } = useContext(SettingsContext);

  const [theme, setTheme] = useState(() => {
    // Check localStorage first
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme;
    }
    // Otherwise check system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  });

  // Theme-Modus aus Settings anwenden
  useEffect(() => {
    const themeMode = settings.themeMode || 'auto';

    // Apply forced theme if set
    if (themeMode === 'force_light') {
      setTheme('light');
      localStorage.setItem('theme', 'light');
    } else if (themeMode === 'force_dark') {
      setTheme('dark');
      localStorage.setItem('theme', 'dark');
    }
  }, [settings.themeMode]);

  // Theme auf Document anwenden
  useEffect(() => {
    // Apply theme to document (including PresentationView)
    document.documentElement.setAttribute('data-theme', theme);

    // Only save to localStorage if not forced
    const themeMode = settings.themeMode || 'auto';
    if (!themeMode.startsWith('force_')) {
      localStorage.setItem('theme', theme);
    }
  }, [theme, settings.themeMode]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  // Hide theme toggle on PresentationView
  if (location.pathname === '/present') {
    return null;
  }

  // Hide theme toggle if theme is forced
  const themeMode = settings.themeMode || 'auto';
  if (themeMode.startsWith('force_')) {
    return null;
  }

  return (
    <button
      onClick={toggleTheme}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        border: '2px solid var(--border-color)',
        background: 'var(--card-bg)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.3s ease',
        zIndex: 9999
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
      title={theme === 'light' ? 'Zu Dunkelmodus wechseln' : 'Zu Hellmodus wechseln'}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
}

export default ThemeToggle;
